(function (app) {
    app.constant("productPlugins", [
        {
            LongName: "FireLight",
            ShortName: "FireLight",
            Description: "E-application"
        },
        //TODO: Remove when rightbridge is 100% gone
        //{
        //    LongName: "RightBRIDGE Annuity Wizard",
        //    ShortName: "RightBridge",
        //    Description: "Product Comparison Tool"
        //},
        {
            LongName: "RetireUp Pro",
            ShortName: "RetireUp",
            Description: "Retirement Planning Tool"
        }
    ]);
})(window.app); // jshint ignore:line